import React, { memo, useEffect, useState, useCallback } from 'react';
import styles from './simcardLoader.module.scss';
import ListHeader from '../../../shared/components/ListHeader';
import ListSimcards from './subcomponets/ListSimcards';
import ListNotFound from '../../../shared/components/ListNotFound';
import FilterSimcards from '../FilterSimcards';
import { useTranslation } from 'react-i18next';
import { defaultLimit, defaultPage } from '../../../app/conf';

export const defaultFilters = {
    full_assigned: 1,
    limit: defaultLimit,
    page: defaultPage
};

const SimcardLoader = ({
    getSimCardsRequest,
    setSimcardSelected,
    setStateSimcards,
    setSimcardsFilters,
    filtersToUseInQuery,
    simCard: { fetching, simCards, submitSuccess, total },
    gps,
    getGpsDevicesRequest
}) => {
    const { t } = useTranslation(['home', 'devices']);

    const [page, setPage] = useState(defaultFilters.page);

    const getMoreItems = () => {
        const _page = page + 1;
        const _filters = {
            ...defaultFilters,
            ...filtersToUseInQuery,
            page: _page
        };

        setPage(_page);
        getSimCardsRequest(_filters);
    };

    const getSimcards = useCallback(() => {
        setStateSimcards({ simCards: [] });
        setPage(defaultFilters.page);
        getSimCardsRequest({ ...defaultFilters, ...filtersToUseInQuery });
    }, [setStateSimcards, getSimCardsRequest, filtersToUseInQuery]);

    useEffect(() => {
        getSimcards();
    }, [getSimcards]);

    useEffect(() => {
        if (submitSuccess) {
            getSimcards();
        }
    }, [getSimcards, submitSuccess]);

    useEffect(() => {
        return () => {
            setStateSimcards({ simCards: [], total: 0, fetching: false });
        };
    }, [setStateSimcards, setSimcardsFilters]);

    return (
        <>
            <FilterSimcards />

            <div className={styles.content}>
                <ListHeader>
                <div> Creación</div>
                    <div> ICCID </div>
                    <div> {t('home:number')} </div>
                    <div> {t('devices:operator')} </div>
                    <div> {t('home:status')} </div>
                    <div></div>
                    
                    <div className={styles.textAlignCenter}> {t('devices:enabled')} </div>
                    <div className={styles.iconColumn}></div>
                </ListHeader>
                {(fetching || simCards.length > 0) && (
                    <ListSimcards
                        simCards={simCards}
                        fetching={fetching && page === 1}
                        setSimcardSelected={setSimcardSelected}
                        totalItems={total}
                        fetchingMoreItems={fetching && page > 1}
                        onScrollBottomAction={getMoreItems}
                        submitSuccess={submitSuccess}
                        gps={gps || {}} 
                        getGpsDevicesRequest={getGpsDevicesRequest} 
                    />
                )}
                {!fetching && simCards.length === 0 && <ListNotFound />}
            </div>
        </>
    );
};

export default memo(SimcardLoader);
